export default "__VITE_ASSET__QEa0VgDD__"